import Vue from 'vue'
import Cookie from 'js-cookie'
import { extractErrorMessage } from '@/utilities/common'

const state = {
  subscription: {
    isPreviewing: false,
    paymentRequirement: null,
    firstTermTaxAmount: null,
    firstTermTotalAmount: null
  },
  bundlesInfor: {
    genericScript: null,
    genericHtml: null,
    pageTitle: null,
    phoneNumberRequired: null,
    phoneNumberVisible: null,
    termsTexts: null
  },
  cartDetails: {
    groups: [
      {
        items: [
          {
            genericScript: null,
            genericHtml: null,
            pageTitle: null
          }
        ]
      }
    ],
    phoneNumberRequired: null,
    phoneNumberVisible: null,
    disablePayment: false
  }
}

const getters = {
  bundlePhoneNumberisRequired: state => state.cartDetails.phoneNumberVisible && state.cartDetails.phoneNumberRequired
}

const mutations = {
  setBundlesInfor (state, bundlesInfor) {
    state.bundlesInfor = Object.assign({}, state.bundlesInfor, bundlesInfor)
  },

  setSubscriptionPreviewInfo (state, subscriptionPreviewInfo) {
    state.subscription.paymentRequirement = subscriptionPreviewInfo.paymentRequirement
    state.subscription.firstTermTaxAmount = subscriptionPreviewInfo.firstTermTaxAmount
    state.subscription.firstTermTotalAmount = subscriptionPreviewInfo.firstTermTotalAmount
  },

  setSubscriptionIsPreviewing (state, isPreviewing) {
    state.subscription.isPreviewing = isPreviewing
  },

  setCartDetails (state, cartDetails) {
    state.cartDetails = cartDetails
  }
}

const actions = {
  async submitOrder ({ state }, { paymentMethodCode, bundles, cancelPaymentUrl }) {
    const trackCookie = Cookie.get('Philips.track')
    const paymentCallBack = await Vue.api.order.submitOrder(bundles, paymentMethodCode, trackCookie, cancelPaymentUrl)
    return paymentCallBack
  },

  async subscriptionPreview ({ commit }, bundles) {
    try {
      commit('setSubscriptionIsPreviewing', true)
      const subscriptionPreviewInfo = await Vue.api.subscription.previewV2(bundles)
      commit('setSubscriptionIsPreviewing', false)
      commit('setSubscriptionPreviewInfo', subscriptionPreviewInfo)
    } catch (e) {
      Vue.prototype.$notify({
        type: 'error',
        title: extractErrorMessage(e)
      })
    }
  },

  async getCartDetails ({ state, commit }, { bundles, excludePrice, zipCode }) {
    const cartDetails = await Vue.api.cart.getCart({
      bundles,
      excludePrice,
      zipCode
    })
    commit('setCartDetails', cartDetails)
    commit('setSubscriptionPreviewInfo', {
      paymentRequirement: cartDetails.paymentRequirement,
      firstTermTaxAmount: cartDetails.firstTermTaxAmount,
      firstTermTotalAmount: cartDetails.firstTermTotalAmount
    })
    return cartDetails
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
